import type { HgClubInfo } from '@ps/web-shared-api-types/v0/SwHomeGames';

import { UserClubRole } from '../types/common';

interface Props {
  clubs?: HgClubInfo[];
  prevClubs?: HgClubInfo[];
}

export const sortClubs = ({ prevClubs = [], clubs = [] }: Props) => {
  // Clubs originally come ordered by date of creation but we want to have customized order which follows these rules:
  // 1. Clubs are ordered from newest to oldest
  // 2. Clubs with UserClubRole.Confirmation go in front of the list
  // 3. Every "new" club temporarily appears first in the list for the sake of animating its entrance
  const newClubs = clubs.filter(
    (club) => !prevClubs.some((sorted) => club.clubId === sorted.clubId)
  );

  if (prevClubs.length === 0 || prevClubs.length > clubs.length || newClubs.length === 0) {
    return [...clubs].sort(
      (prev, next) =>
        Number(next.roleForUser === UserClubRole.Confirmation) -
          Number(prev.roleForUser === UserClubRole.Confirmation) || -1
    );
  }

  return [...newClubs, ...prevClubs];
};
